var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    [
      _c("cms-heading", {
        attrs: { title: "Reparaties", icon: "entypo-tools" },
      }),
      _c("cms-heading", { attrs: { title: "Openstaand", level: "2" } }),
      _c(
        "cms-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loadingPending,
              expression: "loadingPending",
            },
          ],
          attrs: {
            placeholder:
              !_vm.pendingRepairs.items || !_vm.pendingRepairs.items.length,
            clickable: "true",
          },
        },
        [
          _c(
            "tr",
            [
              _c(
                "cms-th",
                {
                  attrs: { field: "reference" },
                  model: {
                    value: _vm.sortPending,
                    callback: function ($$v) {
                      _vm.sortPending = $$v
                    },
                    expression: "sortPending",
                  },
                },
                [_vm._v("Referentie")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "startDate" },
                  model: {
                    value: _vm.sortPending,
                    callback: function ($$v) {
                      _vm.sortPending = $$v
                    },
                    expression: "sortPending",
                  },
                },
                [_vm._v("Startdatum")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "endDate" },
                  model: {
                    value: _vm.sortPending,
                    callback: function ($$v) {
                      _vm.sortPending = $$v
                    },
                    expression: "sortPending",
                  },
                },
                [_vm._v("Verwachte einddatum")]
              ),
              _c("cms-th", [_vm._v("Aantal loggers")]),
              _c("cms-th"),
            ],
            1
          ),
          _vm._l(_vm.pendingRepairs.items, function (repair) {
            return _c(
              "tr",
              {
                on: {
                  click: function ($event) {
                    return _vm.showRepair(repair)
                  },
                },
              },
              [
                _c("td", [_vm._v(_vm._s(repair.reference))]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(repair.startDate, "LL"))),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(repair.endDate, "LL"))),
                ]),
                _c("td", [_vm._v(_vm._s(repair.loggers.itemCount))]),
                _c(
                  "td",
                  {
                    staticClass: "actions",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _vm.userIsAdmin
                      ? _c("cms-link", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Wijzigen",
                              expression: "'Wijzigen'",
                            },
                          ],
                          attrs: {
                            icon: "magicon-edit",
                            to: {
                              name: "repair-edit",
                              params: { id: repair.id },
                            },
                          },
                        })
                      : _vm._e(),
                    _c("cms-link", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Reparatie bekijken",
                          expression: "'Reparatie bekijken'",
                        },
                      ],
                      attrs: {
                        icon: "entypo-eye",
                        to: { name: "repair-view", params: { id: repair.id } },
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c("cms-heading", { attrs: { title: "Archief", level: "2" } }),
      _c(
        "cms-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.resolvedPending,
              expression: "resolvedPending",
            },
          ],
          attrs: {
            "item-count": _vm.resolvedRepairs.totalCount || 0,
            "items-per-page": _vm.itemsPerPage,
            placeholder:
              !_vm.resolvedRepairs.items || !_vm.resolvedRepairs.items.length,
            clickable: "true",
          },
          on: {
            page: function ($event) {
              _vm.offset = arguments[0]
            },
          },
        },
        [
          _c(
            "cms-table-header",
            [
              _c(
                "cms-th",
                {
                  attrs: { field: "reference" },
                  model: {
                    value: _vm.sortResolved,
                    callback: function ($$v) {
                      _vm.sortResolved = $$v
                    },
                    expression: "sortResolved",
                  },
                },
                [_vm._v("Referentie")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "startDate" },
                  model: {
                    value: _vm.sortResolved,
                    callback: function ($$v) {
                      _vm.sortResolved = $$v
                    },
                    expression: "sortResolved",
                  },
                },
                [_vm._v("Startdatum")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "endDate" },
                  model: {
                    value: _vm.sortResolved,
                    callback: function ($$v) {
                      _vm.sortResolved = $$v
                    },
                    expression: "sortResolved",
                  },
                },
                [_vm._v("Einddatum")]
              ),
              _c("cms-th", [_vm._v("Aantal loggers")]),
              _c("cms-th"),
            ],
            1
          ),
          _vm._l(_vm.resolvedRepairs.items, function (repair) {
            return _c(
              "tr",
              {
                on: {
                  click: function ($event) {
                    return _vm.showRepair(repair)
                  },
                },
              },
              [
                _c("td", [_vm._v(_vm._s(repair.reference))]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(repair.startDate, "LL"))),
                ]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(repair.endDate, "LL"))),
                ]),
                _c("td", [_vm._v(_vm._s(repair.loggers.itemCount))]),
                _c(
                  "td",
                  {
                    staticClass: "actions",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _vm.userIsAdmin
                      ? _c("cms-link", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Wijzigen",
                              expression: "'Wijzigen'",
                            },
                          ],
                          attrs: {
                            icon: "magicon-edit",
                            to: {
                              name: "repair-edit",
                              params: { id: repair.id },
                            },
                          },
                        })
                      : _vm._e(),
                    _c("cms-link", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Reparatie bekijken",
                          expression: "'Reparatie bekijken'",
                        },
                      ],
                      attrs: {
                        icon: "entypo-eye",
                        to: { name: "repair-view", params: { id: repair.id } },
                      },
                    }),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }